import {Observable, timer} from 'rxjs';
import * as _ from 'lodash-es';

export const FLASH_MESSAGE_ANIMATION_TIME = 300;
export const DEFAULT_FLASH_MESSAGE_LIFE_TIME = 2000;

export interface FlashMessageOptions {
    message: string;
    targetElement: HTMLElement;
    messageArguments?: any;
    widthType?: FlashMessageWidthType;
    lifeTime?: number;
}

export enum FlashMessageWidthType {
    SMALL = 'small',
    NORMAL = 'normal',
    LARGE = 'large'
}

export class FlashMessage {
    public destroy$: Observable<any>;
    public hide$: Observable<any>;
    public message: string;
    public targetElement: HTMLElement;
    public messageArguments: any;
    public widthType: FlashMessageWidthType = FlashMessageWidthType.NORMAL;
    public lifeTime: number = DEFAULT_FLASH_MESSAGE_LIFE_TIME;
    public animationTime: number = FLASH_MESSAGE_ANIMATION_TIME;

    constructor(
        options: FlashMessageOptions
    ) {
        _.assign(this, options);

        const hideTime = Math.max(0, this.lifeTime - this.animationTime);

        this.destroy$ = timer(this.lifeTime);

        this.hide$ = timer(hideTime);
    }
}
